import { Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { HttpUtils } from "../shared/http.utils";
import { BasicFilters } from "../model/filters/basic-filters";
import { ApplicationSubscriptionPersistRequest } from "../model/requests/application-subscription-persist-request";
import { ApplicationSubscriptionFilters } from "../model/filters/application-subscription-filters";

@Injectable({
  providedIn: 'root'
})
export class ApplicationSubscriptionsService {

  private readonly subscriptionsURL: string;

  constructor(private http: HttpClient) {
    this.subscriptionsURL = "/catalog/application_subscriptions";
  }

  public getSubscriptions(offset?: number, limit?: number, filters?: ApplicationSubscriptionFilters): Observable<any>{
    let options = HttpUtils.buildOptions(HttpUtils.buildListParams(offset, limit));
    let body = (filters != null) ? filters : new ApplicationSubscriptionFilters();
    return this.http.post<any>(this.subscriptionsURL, body, options);
  }

  public createApplicationSubscription(subscriptionCreationData: ApplicationSubscriptionPersistRequest) {
    let url = `${this.subscriptionsURL}/create`;
    return this.http.post<any>(url, subscriptionCreationData);
  }

  public editApplicationSubscription(subscriptionCreationData: ApplicationSubscriptionPersistRequest) {
    let url = `${this.subscriptionsURL}/edit`;
    return this.http.post<any>(url, subscriptionCreationData);
  }

  public toggletApplicationSubscription(name: string, tenantUuid: string) {
    let url = `${this.subscriptionsURL}/toggle`;
    return this.http.put<any>(url, { name, tenantUuid });
  }


  public deleteApplicationSubscriptions(identifiers: {tenantUuid: string, name: string}[]) {
    let url = `${this.subscriptionsURL}/delete`;
    return this.http.post<any>(url, identifiers, {observe: 'response'});
  }

}
